import PropTypes from 'prop-types'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import DynamicImage from 'components/DynamicImage'
import RenderInView from 'components/RenderInView'
import { LocalizationContext } from 'contexts/Localization'
import { Text } from 'styles/components/typography'

import { calcDnaBarWidth } from '../../../utils'

import { timeline } from './animation'
import {
  Bar,
  BarWrapper,
  ChartWrapper,
  DnaIndicators,
  ImageWrapper,
  WgsIndicators,
} from './styles'

const Bars = ({ isTablet, item }) => {
  const imageSizes = React.useMemo(() => ({ xs: 100, md: 130 }), [])
  const wgsBar = React.useRef()
  const dnaBar = React.useRef()
  const { paths } = React.useContext(LocalizationContext)
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true,
  })

  React.useEffect(() => {
    const animation =
      isTablet &&
      timeline({
        wgsBar,
        dnaBar,
        dnaBarWidth: calcDnaBarWidth(item.wgs_indicators, item.dna_indicators),
      })
    if (inView && isTablet) {
      animation.play()
    }

    return () => animation && animation.kill()
  }, [inView, isTablet, item.wgs_indicators, item.dna_indicators])

  return (
    <div ref={ref}>
      <WgsIndicators>
        <ChartWrapper>
          <ImageWrapper>
            <RenderInView>
              <DynamicImage
                alt="wgs-box-left"
                imageSizes={imageSizes}
                imageType="png"
                image={`${paths.cdn_boxes}/wgs-left-new`}
              />
            </RenderInView>
          </ImageWrapper>
          <BarWrapper>
            <Bar ref={wgsBar} />
            <Text
              dangerouslySetInnerHTML={{
                __html: item.wgs_indicators,
              }}
            />
          </BarWrapper>
        </ChartWrapper>
      </WgsIndicators>

      <DnaIndicators>
        <ChartWrapper>
          <ImageWrapper>
            <RenderInView>
              <DynamicImage
                alt="dna-box-left"
                imageSizes={imageSizes}
                imageType="png"
                image={`${paths.cdn_boxes}/dna-left-new`}
              />
            </RenderInView>
          </ImageWrapper>
          <BarWrapper>
            <Bar
              ref={dnaBar}
              isGray={true}
              style={{
                width: `${calcDnaBarWidth(
                  item.wgs_indicators,
                  item.dna_indicators,
                )}%`,
              }}
            />
            <Text dangerouslySetInnerHTML={{ __html: item.dna_indicators }} />
          </BarWrapper>
        </ChartWrapper>
      </DnaIndicators>
    </div>
  )
}

Bars.propTypes = {
  item: PropTypes.object.isRequired,
  isTablet: PropTypes.bool,
}

export default Bars
